/**
 * QA-397 — 휴대전화 표시 형식 통일(하이픈 없이). 고도몰 이관 데이터는 "010-0000-0000" 으로, BO 에서 수정한 값은
 * BE 가 숫자만 남겨 "01000000000" 으로 저장돼 화면에 두 형식이 섞여 보였다. 표시만 하이픈·공백을 뺀다
 * (가린 값 "010-****-5678" 도 "010****5678"). 저장값은 바꾸지 않는다.
 */
export const mobileDisplay = (value: string | null | undefined): string =>
  typeof value === 'string' ? value.replace(/[-\s]/g, '') : '';
